import { AiOutlineQuestionCircle } from "react-icons/ai";
import { formatToReal } from "../../utils/utils";
import { AdditionalsQuery } from "../queries/AdditionalsQuery";
import { Tooltip } from "react-tooltip";

const CardQueryDescription = ({
  title,
  infos,
  children,
  price,
  imageBanner = "/assets/bg_queries.jpg",
}) => {
  let logoSrc;

  switch (true) {
    case window.location.href.includes("datacredi"):
      logoSrc = "/assets/data-credi/logo.png";
      break;
    default:
      logoSrc = "/assets/logo_avalie.png";
      break;
  }

  return (
    <div
      className="relative bg-gray-300 shadow-md rounded-lg bg-cover p-5 mb-5"
      style={{ backgroundImage: `url('${imageBanner}')` }}
    >
      <div className="relative">
        <img src={logoSrc} className="w-28 hidden md:block mb-3 absolute top-1 right-2" />
        <div className="font-semibold text-xl md:text-2xl mt-2 text-green-900 mb-3 flex gap-2 items-center">
          <div>{title}</div>
          <div>
            <Tooltip
              id="tooltip-query"
              content={
                infos?.length > 0 && (
                  <ul
                    className="flex flex-wrap gap-2 text-sm"
                    style={{ maxWidth: "480px" }}
                  >
                    {infos?.map((info, index) => (
                      <li
                        key={index}
                        className={`relative ${
                          index + 1 !== infos.length
                            ? "after:content-['|'] after:absolute after:right-0 after:pl-2"
                            : ""
                        }  pr-3`}
                      >
                        {info}
                      </li>
                    ))}
                  </ul>
                )
              }
            />
            <AiOutlineQuestionCircle data-tooltip-id="tooltip-query" />
          </div>
        </div>
        {/* {infos?.length > 0 && (
          <ul
            className="flex flex-wrap gap-2 mb-5 text-sm"
            style={{ maxWidth: "480px" }}
          >
            {infos?.map((info, index) => (
              <li
                key={index}
                className={`relative ${
                  index + 1 !== infos.length
                    ? "after:content-['|'] after:absolute after:right-0 after:pl-2"
                    : ""
                }  pr-3`}
              >
                {info}
              </li>
            ))}
          </ul>
        )} */}
        {/* <div className="mb-2 font-semibold text-sm">Incremente ainda mais sua consulta:</div>
        <div className="w-fit mb-4">
          <AdditionalsQuery />
        </div> */}
        {children}
      </div>
    </div>
  );
};

export default CardQueryDescription;
